export const getPCMData = (audioData: Float32Array): ArrayBuffer => {
  const buffer = new ArrayBuffer(audioData.length * 2); // 16-bit PCM
  const view = new DataView(buffer);
  for (let i = 0; i < audioData.length; i++) {
    const value = Math.max(-1, Math.min(1, audioData[i])); // Ограничиваем значение
    view.setInt16(i * 2, value < 0 ? value * 0x8000 : value * 0x7fff, true); // Преобразуем в 16-bit PCM
  }
  return buffer;
};

// Отправка накопленных данных через WebSocket
export const sendAccumulatedData = (buffer: Float32Array[], websocket: WebSocket | null) => {
  if (websocket?.readyState !== WebSocket.OPEN || !buffer.length) return;

  const totalLength = buffer.reduce((acc, buffer) => acc + buffer.length, 0);
  const combinedData = new Float32Array(totalLength);
  let offset = 0;

  for (const b of buffer) {
    combinedData.set(b, offset);
    offset += b.length;
  }

  // const url = new URL(websocket.url);
  // console.log(`>>> Send audio data len: ${totalLength} to ${url.pathname.split('/').at(-1)}`);

  websocket.send(combinedData.buffer);
  buffer.length = 0;
};

export const defineSampleRate = async (
  supportedSampleRates: number[],
  targetSampleRate: number
): Promise<{ mediaStream: MediaStream; sampleRate: number } | { error: string }> => {
  // создаем медиастрим
  const stream = await navigator.mediaDevices.getUserMedia({
    audio: {
      echoCancellation: true,
      noiseSuppression: false,
      autoGainControl: true,
    },
  });

  try {
    // создаем аудио контекст с целевой ЧД
    const testAudioContext = new AudioContext({
      sampleRate: targetSampleRate,
    });

    // подключаем к нему стрим.
    // подлкючение упадет, если установка кастомной ЧД не поддерживается браузером
    testAudioContext.createMediaStreamSource(stream);
    console.log(`Target sample rate is set: ${targetSampleRate}`);

    return { mediaStream: stream, sampleRate: targetSampleRate };
  } catch (error) {
    // определяем какую ЧД поддерживает браузер
    const context = new AudioContext();
    context.createMediaStreamSource(stream);
    const browserSampleRate = context.sampleRate;

    console.log(`Browser sample rate: ${browserSampleRate}`);

    // проверяем, что распознавание яндекса поддерживает эту ЧД
    if (supportedSampleRates.includes(browserSampleRate)) {
      return { mediaStream: stream, sampleRate: browserSampleRate };
    } else {
      return {
        error:
          'Не удалось запустить распознавание речи. Ваш микрофон или браузер используют неподдерживаемые параметры звука.',
      };
    }
  }
};
